//


import ListItemIcon from '@mui/material/ListItemIcon'

export function Icon(props) {
  const { children, classes, className, ...additionalProps } = props
  return (
    <ListItemIcon classes={classes} className={className} {...additionalProps}>
      {children}
    </ListItemIcon>
  )
}

Icon.displayName = 'Icon'

export default Icon
